import './../index.css';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import React from 'react';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import useStorage from './../hooks/useStorage';

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ width: '50%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="white">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default function PhotoGallery({ file, setFile, setSuccessAlert }) {

  const { progress, url } = useStorage(file);
  console.log(progress);
  console.log(url);

  if (progress === 100 && url) {
    setFile(null);
    setSuccessAlert(true);
  }

  return (
    <div className='photo-gallery-div'>
      <Box sx={{ width: '50%', marginLeft: '37%', marginTop: '2%' }}>
        <LinearProgressWithLabel value={progress} />
      </Box>
    </div>
  )
}